import { chain, get } from 'lodash';

import { SearchCriteriaFields } from '../constants/SearchCriteria';
import ComplianceHttpService from '../api/ComplianceHttpService';
import Logger from './logger';

export default class GdprComplianceService {
    static getPositionLocations(position) {
        const positionLocations = chain(position)
            .get('desiredCandidateProfile.selected')
            .find({ field: SearchCriteriaFields.locations })
            .get('items')
            .value();
        return positionLocations || [];
    }

    static async checkIfPositionIsGdprCompliant({ locations }) {
        try {
            if (!locations?.length) {
                return false;
            }

            const isGdpr = await ComplianceHttpService.checkIfPositionIsGdprCompliant({ locations });
            return isGdpr;
        } catch (error) {
            Logger.error(`[ComplianceService.checkIfPositionIsGdprCompliant] error => ${error?.message}`);
            return false;
        }
    }

    static async getPositionGdprLocations({ locations }) {
        try {
            if (!locations?.length) {
                return [];
            }

            const positionGdprLocations = await ComplianceHttpService.getPositionGdprLocations({ locations });
            return positionGdprLocations;
        } catch (error) {
            Logger.error(`[ComplianceService.getPositionGdprLocations] error => ${error?.message}`);
            return [];
        }
    }

    static checkIfShowCurrentJobTitleInsteadOfName(
        gdprState,
        isImported,
    ) {
        const isGdprCompliant = get(gdprState, 'isGdprCompliant');
        const revealPersonalDataConsent = get(gdprState, 'revealPersonalDataConsent');

        return isGdprCompliant && !revealPersonalDataConsent && !isImported;
    }
}
